var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisibleTicketTemplate,
      callback: function callback($$v) {
        _vm.isVisibleTicketTemplate = $$v;
      },
      expression: "isVisibleTicketTemplate"
    }
  }, [_c('dialog-template', [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.ticket.template.edit.title'))
    },
    slot: "title"
  }), _c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 1,
      expression: "1"
    }, {
      name: "m-b",
      rawName: "v-m-b",
      value: 1,
      expression: "1"
    }],
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "textarea-composite-container"
  }, [_c('input-textarea', {
    attrs: {
      "value": _vm.attachment.name,
      "input-id": "tariff-file-input",
      "input-name": _vm.$t('bill.ticket.template.field.label'),
      "input-title": _vm.$t('bill.ticket.template.field.label'),
      "input-placeholder": _vm.$t('bill.ticket.template.field.placeholder'),
      "show-counter": false,
      "max-length": 255,
      "required": false,
      "rows": 1,
      "composite": "",
      "readonly": ""
    },
    on: {
      "click": _vm.handleAttachment
    }
  }, [_c('help-link', {
    attrs: {
      "slot": "link",
      "source": "https://tilda.cc/page/?pageid=27310997"
    },
    slot: "link"
  })], 1), _c('attachment-image', {
    ref: "attachment",
    attrs: {
      "link": _vm.attachment.link,
      "input-id": "tariff.file",
      "type": "secondary",
      "composite": "",
      "composite-textarea": "",
      "upload-type": "ticket",
      "accept": "application/vnd.ms-word.document.macroEnabled.12, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-word.template.macroEnabled.12"
    },
    on: {
      "loading": _vm.onImageLoading,
      "uploaded": function uploaded(data) {
        return _vm.attachment.setData(data);
      },
      "reset": function reset($event) {
        return _vm.attachment.reset();
      }
    }
  })], 1)]), _c('simple-button', {
    attrs: {
      "slot": "submit",
      "variant": "primary",
      "disabled": _vm.submittingDisabled
    },
    on: {
      "click": _vm.handleSavingTemplate
    },
    slot: "submit"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('simple-button', {
    attrs: {
      "slot": "cancel",
      "variant": "transparent"
    },
    on: {
      "click": _vm.handleClose
    },
    slot: "cancel"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }